const check = (value) => {
    console.log(typeof value)
    if(value === null) {
        return "null"
    }

    if(typeof value === "boolean" ) {
        if(value === true) {
            return "true"
        }

        if(value === false) {
            return  "false"
        }
    }
}

const stringToBool = (stringValue) => {

    if(stringValue === "null") {
        return null
    }

    if(stringValue === "true") {
        return true
    }

    if(stringValue === "false") {
        return false
    }
}


export const nullableBool = {
    check,
    stringToBool
}
